// extracted by mini-css-extract-plugin
export var cancelButton = "_m7-5";
export var content = "_m7-3";
export var createButton = "_m7-6";
export var drawerContainer = "_m7-0";
export var footer = "_m7-2";
export var header = "_m7-1";
export var orderFormColumn = "_m7-4";